import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @ts-ignore
import { Toast } from '@els/els-react--toast';
// @ts-ignore
import { Icon } from '@els/els-react--icon';
import SkillsFavoriteTab from '../skills-favorite-tab/skills-favorite-tab';
import {
    selectFavoriteSkillDeleteStatus,
    selectUserFavoriteContentAsyncStatus,
} from '../skills-favorite-tab/skills-favorite-tab-selector';
import { getUserFavoriteContent } from '../skills-favorite-tab/skills-favorite-tab-thunk';
import { resetDeleteStatus } from '../skills-favorite-tab/skills-favorite-tab-slice';
import './content-tab-group.scss';
import {
    AsyncStatus,
    hasFailed,
} from '../../../../libs/utils/constants/async-status';

const baseClassName = 'skills-favorite';

const RenderDeletedSkillSuccessMessage = () => (
    <Toast
        autoHide
        color="confirm"
        contained
        className={`${baseClassName}__remove-favorite-skill-success-toast`}
    >
        <div className={`${baseClassName}__toast-icon`}>
            <Icon
                id="ConfirmationOutlineCircle"
                sprite="ConfirmationOutlineCircle"
                color="positive"
                isVisible
                size="m"
                a11y={{ name: 'Icon Name', description: 'Icon description' }}
                className={`${baseClassName}__remove-question-success-toast-wrapper-icon`}
            />
            <span className={`${baseClassName}__toast-skill-title`}>
                &nbsp;Skill was successfully removed &nbsp;from your favorites.
            </span>
        </div>
    </Toast>
);

const ContentTabGroup = () => {
    const baseClassName = 'content-tab-group';
    const dispatch = useDispatch();
    const [isDeleteSuccessMessage, setIsDeleteSuccessMessage] = useState(false);
    const isDeleteSuccess = useSelector(selectFavoriteSkillDeleteStatus);
    const userFavoriteContentAsyncStatus = useSelector(
        selectUserFavoriteContentAsyncStatus
    );

    useEffect(() => {
        if (isDeleteSuccessMessage) {
            setTimeout(() => {
                setIsDeleteSuccessMessage(false);
            }, 2000);
        }
    }, [isDeleteSuccessMessage]);

    useEffect(() => {
        if (isDeleteSuccess === AsyncStatus.SUCCESS) {
            dispatch(getUserFavoriteContent());
            setIsDeleteSuccessMessage(true);
            dispatch(resetDeleteStatus());
        }
    }, [isDeleteSuccess]);

    return (
        <div className={`${baseClassName}`}>
            {isDeleteSuccessMessage && <RenderDeletedSkillSuccessMessage />}
            {!hasFailed(userFavoriteContentAsyncStatus) && (
                <h2 className={`${baseClassName}_header`}>Skills</h2>
            )}
            <SkillsFavoriteTab />
        </div>
    );
};

export default ContentTabGroup;
